import React, { useEffect, useCallback } from "react";
import { Route, Switch, HashRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import * as authActions from './store/auth/auth.actions';
import Auth from './pages/Auth/Auth';
import Checkout from "./pages/Checkout/Checkout";
import Contact from './pages/Contact/Contact';
import Footer from "./components/Footer/Footer";
import Header from './components/Header/Header';
import Home from './pages/Home/Home';
import PrivateComponent from "./hocs/PrivateComponent/PrivateComponent";
import Logout from './pages/Auth/Logout/Logout';
import Orders from "./pages/Orders/Orders";
import * as familiasActions from './store/familias/familias.actions';
import FamilyNav from './components/FamiliaNav/FamiliaNav';
import Spinner from "./core/Spinner/Spinner";
import ProductList from "./components/ProductList/ProductList";
import Forgot from "./pages/Forgot/Forgot";
import Reset from "./pages/Forgot/Reset";

const AppRouter: React.FunctionComponent<any> = ({ location }) => {
    const dispatch = useDispatch();
    const { error, familias, fetching } = useSelector((state: any) => state.familiasStore);

    const fetchData = useCallback(() => {
        if (!familias.length) dispatch(familiasActions.requestFamilias());
    }, [dispatch, familias.length]);

    useEffect(() => { 
        dispatch(authActions.tryAutoLogin()); 
        fetchData();
    }, [dispatch]);

    const renderFamiliaList = () => {
        if (error) {
            return <p>Hubo un error</p>;
        }

        if (fetching) {
            return <Spinner>Buscando categorías...</Spinner>;
        }
        
        return <FamilyNav familias={familias} />
    }
    return (
        <HashRouter>
            <div className="main-container">
                <div>
                    <Header />
                </div>
                <div className="content-container">
                    <div className="container">
                    
                        <div className="row" style={{ paddingTop: '50px' }}>
                            <div className="FamiliasContainer col-md-3">
                                <div className="FamiliaList">
                                    {renderFamiliaList()}
                                </div>
                            </div>
                            <div className="col-md-9">
                                <Switch>
                                    <Route
                                        path="/productos"
                                        component={ProductList} />
                                    <Route
                                        path="/mis-pedidos"
                                        component={PrivateComponent(Orders)}
                                        exact={true} />
                                    <Route
                                        path="/checkout"
                                        component={PrivateComponent(Checkout)}
                                        exact={true} />

                                    <Route
                                        path="/logout"
                                        component={Logout}
                                        exact={true} />
                                    <Route
                                        path="/"
                                        component={Home}
                                        exact={true} />
                                    <Route
                                        path="/contacto" 
                                        component={Contact}
                                        exact={true} />
                                    <Route
                                        path="/ingresar" 
                                        component={Auth}
                                        exact={true} />
                                    <Route
                                        path="/registrarme"
                                        component={Auth}
                                        exact={true} />
                                    <Route
                                        path="/olvide-mi-contrasena"
                                        component={Forgot}
                                        exact={true} />
                                    <Route
                                        path="/new-password"
                                        component={Reset}
                                        exact={true} />
                                </Switch>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div>
                    <Footer />
                </div>
            </div>
        </HashRouter>
    );
};

export default AppRouter;